<div class="container-fluid">
  <div class="w-450px">
    <iui-messages #message class="ms-auto me-auto"></iui-messages>
  </div>
  <div>
    <h5>Data from 10/15/2024 and earlier is from the previous Vetting Agent. Data from after 10/16/2024 is from the current Vetting Agent.</h5>
    <br>
  </div>
  <form #vettingForm="ngForm" name="vettingandmonitoringForm" (ngSubmit)="submitQuery(vettingForm)">
    <div class="row mb-4">
      <div class="col-4">
        <p-radioButton name="companyNameRadioBtn" id="companyNameRadioBtn" value="companyName" label="Organization Name" [(ngModel)]="radioBtnSelection"
          (onClick)="filterChoices.shortCode = ''">
        </p-radioButton>
        <input appScrText placeholder="Enter all or part of the organization name" name="companyNameInput" id="companyNameInput" class="mt-2 ms-4"
          [disabled]="radioBtnSelection !== 'companyName'" [(ngModel)]="filterChoices.companyName" minlength="3" maxlength="{{MaxLen.Company}}" #companyName="ngModel">
        <div class="ms-4">
          <app-error-msg [field]="companyName" fieldLabel="Organization Name" [form]="vettingForm">
          </app-error-msg>
        </div>
      </div>
      <div class="col-4 ms-5">
        <div class="col-6">
          <p-radioButton name="shortCodeRadioBtn" id="shortCodeRadioBtn" value="shortCode" label="Short Code" [(ngModel)]="radioBtnSelection"
            (onClick)="filterChoices.companyName = ''"></p-radioButton>
          <input appScrText placeholder="Short Code" name="shortCodeInput" id="shortCodeInput" class="mt-2 ms-4" [disabled]="radioBtnSelection !== 'shortCode'"
            [(ngModel)]="filterChoices.shortCode" maxlength="{{MaxLen.ShortCode}}" minlength="5" appAlphaNumOnly #shortCode="ngModel" appShortCodeValidator>
        </div>
        <div class="ms-4">
          <app-error-msg [field]="shortCode" fieldLabel="Short Code" [form]="vettingForm"></app-error-msg>
        </div>
      </div>
    </div>
    <div class="row mb-4 ms-4">
      <div class="col-4 ps-0">
        <label name="vetTypeDropdownLabel" id="vetTypeDropdownLabel" class="d-block" for="vetTypeDropdown">Vet
          Type</label>
        <p-multiSelect appendTo="body" name="vetTypeDropdown" id="vetTypeDropdown" appTid [options]="vetTypeOptions" optionLabel="name" optionValue="name"
          [selectedItemsLabel]="'{0} items selected'" [filter]="false" [showHeader]=false [(ngModel)]="filterChoices.vetTypeChoices">
        </p-multiSelect>
      </div>
    </div>
    <div class="row mb-4 ms-4">
      <div class="col-4 ps-0">
        <label for="findingsDropdown" name="findingsDropdownLabel" id="findingsDropdownLabel" class="d-block">Findings</label>
        <p-multiSelect appendTo="body" name="findingsDropdown" id="findingsDropdown" appTid [options]="findingsOptions" optionLabel="name" optionValue="name"
          [selectedItemsLabel]="'{0} items selected'" [(ngModel)]="filterChoices.findingsChoices">
        </p-multiSelect>
      </div>
    </div>
    <div class="ms-4">
      <h5>Date Range</h5>
      <div class="row mb-4">
        <div class="col-2">
          <label for="startDate" name="startDateLabel" id="startDateLabel">Start</label>
          <p-calendar name="startDate" id="startDateWidget" placeholder="Start Date" [showIcon]="true" inputId="startDate" dateFormat="yy-mm-dd"
            [(ngModel)]="filterChoices.startDate" [maxDate]="today"></p-calendar>
        </div>
        <div class="col-2">
          <label for="endDate" [ngClass]="{required: filterChoices.startDate !== null}">End</label>
          <p-calendar name="endDateWidget" id="endDateWidget" placeholder="End Date" [showIcon]="true" inputId="endDate" dateFormat="yy-mm-dd" [disabled]="!filterChoices.startDate"
            [maxDate]="today" [(ngModel)]="filterChoices.endDate" #endDate="ngModel" [required]="filterChoices.startDate !== null"></p-calendar>
          <!-- Double negate required to make boolean. Maybe a function returning is better? -->
          <div class="ms-3">
            <app-error-msg [field]="endDate" fieldLabel="End Date" [form]="vettingForm"></app-error-msg>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-6">
          <button class="btn btn-primary" type="submit">Get Report</button>
          <button class="btn btn-secondary ms-3" (click)="hardResetQuery()" type="button">Reset Query</button>
        </div>
      </div>
    </div>
  </form>

  <div class="row" *ngIf="showResults">
    <h5>Results</h5>
    <div class="col-12">
      <p-table styleClass="p-datatable-striped" #VettingInsights [columns]="tableColumn" [value]="results" dataKey="uniqueId" *ngIf="showResults" [paginator]="true" [rows]="100"
        currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})" [showCurrentPageReport]="true" [alwaysShowPaginator]="false">
        <!-- Template paginatorright as a hacky way to add spacing. DO NOT REMOVE!!! -->
        <ng-template pTemplate="paginatorright" let-state></ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="small-column-flex-override"></th>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="!col.sort">{{col.header}}</th>
              <th *ngIf="col.sort" class="noBorder" [style.width.%]="col.width" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
          <tr>
            <td class="small-column-flex-override">
              <button type="button" pButton pRipple [pRowToggler]="rowData" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'fas fa-minus' : 'fas fa-plus'"
                (click)="getAccountInfo(rowData.accountId, rowData.companyName, rowData.vetType, rowData.uniqueId)">
              </button>
            </td>
            <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'customerSince'">
                {{ rowData[col.field] | date: 'M/d/yyyy' }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ rowData[col.field] }}
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData>
          <tr *ngIf="rowData.expandedDetails" style="width: 99%;">
            <td colspan="7" *ngIf="!rowData.accountId">
              <div class="ms-5">
                <div class="row">
                  No Registry account is associated with these findings.
                </div>
              </div>
            </td>
            <td colspan="7" *ngIf="rowData.accountId">
              <div class="ms-5">
                <div class="col-12">
                  Aliases: {{ getExpandedAlias(rowData.expandedDetails) }}
                </div>
                <div class="col-12">
                  FEIN: {{ rowData.expandedDetails.fein }}
                </div>
                <div class="col-12">
                  Account Contact:&nbsp;
                  <span *ngIf="rowData.expandedDetails.firstName">{{rowData.expandedDetails.firstName}} {{rowData.expandedDetails.lastName}}</span>
                  <span *ngIf="rowData.expandedDetails.phone">, {{rowData.expandedDetails.phone | phoneNumber }}</span>
                  <span *ngIf="rowData.expandedDetails.phoneExtension">, Extension&nbsp; {{rowData.expandedDetails.phoneExtension}}</span>
                  <span *ngIf="rowData.expandedDetails.email">, {{rowData.expandedDetails.email}}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="rowData.expandedDetails" class="mx-2">
            <td [attr.colspan]="tableColumn.length + 1" class="px-5">
              <p-table styleClass="p-datatable-striped" #ExpandedVetInsights [columns]="innerTableColumn" [value]="rowData.expandedDetails.vetInsights" [scrollable]="true"
                scrollHeight="50vh">
                <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th>{{col.header}}</th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'notificationDate'">
                {{ rowData[col.field] | date: 'M/d/yyyy' }}
              </ng-container>
              <ng-container *ngSwitchCase="'finding'">
                <span *ngIf="rowData['determination'] === 'bad'" style="color: red;">{{rowData[col.field]}}</span>
                <span *ngIf="rowData['determination'] === 'good'" style="color: green;">{{rowData[col.field]}}</span>
                <span *ngIf="rowData['determination'] === '- -'">{{rowData[col.field]}}</span>
              </ng-container>
              <ng-container *ngSwitchCase="'determination'">
                <i *ngIf="rowData[col.field] === 'good'" class="fa-solid fa-circle-check" style="color: green;"></i>
                <i *ngIf="rowData[col.field] === 'bad'" class="fa-solid fa-triangle-exclamation" style="color: red;"></i>
                <span *ngIf="rowData[col.field] === '- -'">{{rowData[col.field]}}</span>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ rowData[col.field] }}
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length + 1" class="noBorder">
              <b>No Records found.</b>
            </td>
          </tr>
        </ng-template>
      </p-table>
      </td>
      </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 1" class="noBorder">
            <b>No Records found.</b>
          </td>
        </tr>
      </ng-template>
      </p-table>
    </div>
  </div>